












































































































































































import { PropValidator } from 'vue/types/options';

import mixins from '@/utils/mixins';
import { humanReadableFileSize, wrapInArray } from '@/utils/helpers';
import RenderlessDragAndDrop from './RenderlessDragAndDrop.vue';
import colorable from '@/mixins/colorable';

// Declare validation to align with vuetify v-form validation
const baseMixins = mixins(colorable);
interface Options extends InstanceType<typeof baseMixins> {
  /* eslint-disable-next-line camelcase */
  $_modelEvent: string;
  $refs: {
    input: InstanceType<typeof RenderlessDragAndDrop>;
  };
}
export default baseMixins
  .extend<Options>({ functional: false })
  .extend({
    components: { RenderlessDragAndDrop },
    name: 'DragDropFileInput',

    props: {
      value: {
        default: undefined,
        validator: val => {
          return wrapInArray(val).every(
            v => v != null && typeof v === 'object'
          );
        }
      } as PropValidator<null | File | File[]>,

      clearable: Boolean,
      disabled: Boolean,
      readonly: Boolean,
      // override color property to get primary as default
      placeholder: { type: String, default: 'Drag xlsx file here' },
      accept: { type: String, default: '.xls, .xlsx' },
      color: { type: String, default: 'primary' },
      truncateLimit: { type: Number, default: 50 },
      height: { type: Number, default: 250 },
      flat: { type: Boolean, default: true },
      borderDraggingColor: { type: String },
      multiple: { type: Boolean, default: false },
      error: { type: Boolean, default: false }
    },

    data() {
      return {
        dragging: false,
        lazyValue: this.value
      };
    },

    watch: {
      value(val) {
        this.lazyValue = val;
      }
    },

    computed: {
      internalValue: {
        get(): null | File | File[] {
          return this.lazyValue;
        },
        set(val: null | File | File[]) {
          this.lazyValue = val;

          this.$emit('input', val);
        }
      },

      internalArrayValue(): File[] {
        return wrapInArray(this.internalValue);
      },

      isDirty(): boolean {
        return this.internalArrayValue.length > 0;
      },

      borderStyle(): any {
        const borderColor = !this.$attrs['error-messages']
          ? '0000002E'
          : 'DE3730';

        const strokeDashArray =
          this.isDirty && !this.multiple ? '0' : '6%2c 10';

        return {
          'background-image': `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23${borderColor}' stroke-width='3' stroke-dasharray='${strokeDashArray}' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`
        };
      }
    },

    methods: {
      displayText(str: string) {
        // if box is small then we want to make this size smaller
        if (str.length < this.truncateLimit) return str;
        const charsKeepOneSide = Math.floor((this.truncateLimit - 1) / 2);
        return `${str.slice(0, charsKeepOneSide)}…${str.slice(
          str.length - charsKeepOneSide
        )}`;
      },

      // allow clearing the value from external activator
      clearableCallback() {
        this.$nextTick(() => {
          this.internalValue = this.multiple ? [] : null;
        });
      },

      fileText(file: File): string {
        if (!file) return '';
        const { name = '' } = file as File;
        const truncatedText = this.displayText(name);
        return `${truncatedText}`;
      },

      fileSize(file: File): string {
        if (!file) return '';
        const { size = 0 } = file as File;
        return `${humanReadableFileSize(size, false)}`;
      },

      validate(): boolean {
        return this.$refs.input ? this.$refs.input.validate() : false;
      },

      removeFileFromList(file: File) {
        // this.value will always be an array of files because this function only applies when removing a file from multiple
        const files = Array.from(this.value as File[]);
        const indexOfFile = files.indexOf(file);
        files.splice(indexOfFile, 1);

        this.internalValue = files;
      }
    }
  });
